import "./AboutUs.module.css";
import HeaderPrincipale from "@/reusable_sections/Header";
import UnaziendaItaliana from "./sections/UnaziendaItaliana";
import Footer from "../Home/sections/Footer";
export default function AboutUsPage() {
  return <div>
      <HeaderPrincipale />
      <UnaziendaItaliana />
      <Footer />
    </div>;
}